import React, { ReactElement, useContext } from 'react';
import Typography from '@material-ui/core/Typography';
import { Paper, Grid, Button, Box } from '@material-ui/core';
import { AuthContext } from 'context/AuthContext';
import GoogleIcon from 'assets/icons/GoogleIcon';
import LockIcon from '@material-ui/icons/Lock';
import useAuth from 'hooks/useAuth';
import useStyles from './style';

const Login: React.FC<{}> = (): ReactElement => {
  const classes = useStyles();
  const { signInWithGoogle } = useAuth();
  const { dispatchLoading } = useContext(AuthContext);

  const handleLoginButtonClick = (): void => {
    dispatchLoading(true);
    signInWithGoogle();
  };

  return (
    <Box className={classes.box}>
      <Paper className={classes.container}>
        <Grid
          container
          alignItems='center'
          alignContent='center'
          direction='column'
        >
          <div className={classes.title}>
            <div className={classes.lockIcon}>
              <LockIcon fontSize='large' style={{ color: '#fff' }} />
            </div>
            <Typography variant='h5' className={classes.logIn}>
              Log In
            </Typography>
          </div>
          <Grid item md sm xs>
            <Button
              variant='contained'
              className={classes.button}
              startIcon={<GoogleIcon active />}
              onClick={handleLoginButtonClick}
            >
              <Typography>Sign in with Google</Typography>
            </Button>
          </Grid>
        </Grid>
      </Paper>
    </Box>
  );
};

export default Login;
